import { ApiService } from './../../services/api/api.service';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { HouseComponent } from './components/house/house.component';
import { StartComponent } from './components/start/start.component';
import { CompleteComponent } from './components/complete/complete.component';
import { QualificationComponent } from './qualification.component';
import { MatFieldComponent } from './../../components/mat-field/mat-field.component';
import { ContactDetailsComponent } from './components/contact-details/contact-details.component';
import { ActivateComponent } from './components/activate/activate.component';
import { PleaseContactComponent } from './components/please-contact/please-contact.component';
import { PolicyDialogComponent } from './components/policy-dialog/policy-dialog.component';
import { NoPolicyComponent } from './components/no-policy/no-policy.component';
import { GoogleAutoCompleteDirective } from './components/start/google-autocomplete.directive';
import { DwellingService } from '../../services/dwelling/dwelling.service';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';

import { ZipcodeDialogComponent } from './components/zipcode-dialog/zipcode-dialog.component';
import { EbbIntegrationModule } from '../../ebb-integration.module';
import { AppLoadService } from '../../services/app-load.service';
import { MultiPolicyComponent } from './components/multi-policy/multi-policy.component';
import { PleaseContactEssComponent } from './components/please-contactess/please-contactess.component';
import { AddressStandardizeService } from '../../services/address/addressstandardize.service';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatStepperModule } from '@angular/material/stepper';
import { NotQualifiedPolicyComponent } from './components/not-qualified/not-qualifiedpolicy.component';
import { HelpApiService } from '../../services/data/help-api.service';
import { HelpGqlService } from '../../services/data/dynamics/help-gql.service';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ModalModule } from 'ngx-bootstrap/modal';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from '../../services/errorinterceptor/error-interceptor.service';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { RecaptchaModule,  RECAPTCHA_SETTINGS, RecaptchaSettings, RecaptchaFormsModule } from 'ng-recaptcha';

export function get_environ_settings(appLoadService: AppLoadService) {
  return () => appLoadService.getEnvironSettings();
}

@NgModule({
  declarations: [
    HouseComponent,
    StartComponent,
    QualificationComponent,
    MatFieldComponent,
    ContactDetailsComponent,
    ActivateComponent,
    CompleteComponent,
    GoogleAutoCompleteDirective,
    NoPolicyComponent,
    PleaseContactComponent,
    PleaseContactEssComponent,
    NotQualifiedPolicyComponent,
    PolicyDialogComponent,
    ZipcodeDialogComponent,
    MultiPolicyComponent
    
  ],
  // entryComponents: [ PolicyDialogComponent, ZipcodeDialogComponent ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    EbbIntegrationModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatSidenavModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDialogModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    NgxTrimDirectiveModule,NgxMaskDirective,NgxMaskPipe,
    ModalModule.forRoot(),
    RecaptchaModule,
    RecaptchaFormsModule
   
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ApiService,provideNgxMask(),
    AppLoadService,
    { provide: APP_INITIALIZER, useFactory: get_environ_settings, deps: [AppLoadService], multi: true },
    {
      provide: RECAPTCHA_SETTINGS,
      useFactory: (appLoadService: AppLoadService): RecaptchaSettings => ({
        siteKey: appLoadService.getRecaptchaKey()
      }),
      deps: [AppLoadService]
    },
    DwellingService,
    AddressStandardizeService,  { provide: HelpApiService, useClass: HelpGqlService }
  ]
})
export class QualificationModule { }
